import { serverResponse } from "../util/fakeServer";

// Costruisce l'exportObj per grocery-list/write dalla lista redux, SENZA mutare
// lo stato (a differenza del vecchio buildGroceryExportObj in GroceryList).
// Genera un id_param_url NUOVO ad ogni chiamata.
export const buildGroceryExportObj = (groceryList = {}, user = null) => {
  const trunc = (v) => (v ? String(v).substring(0, 80) : "");

  const prodotti = (groceryList.list || []).map((el) => ({
    ...el,
    image_file: el.images && el.images[0] ? el.images[0].image_file : "",
    description: trunc(el.description || el.field1),
    field1: trunc(el.field1),
    field2: trunc(el.field2),
    field3: trunc(el.field3),
    field4: trunc(el.field4),
  }));

  const idParam = Math.random().toString(36).substr(2, 16);

  const exportObj = {
    id_param_url: idParam,
    id_campagna: groceryList.idCampaign,
    flyer_url:
      window.location.host === "preview.interattivo.net"
        ? "preview"
        : `${process.env.REACT_APP_VIEW}/${serverResponse.config.client_code}/${serverResponse.config.slug}`,
    prodotti,
    pid: user ? user.id : null,
  };

  return { exportObj, idParam };
};
